import { type CSSResultArray, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";

import logo from "../../images/optimized/logo.svg?raw";
import styles from "./lead-email-preview.scss";

@customElement("oz-lead-email-preview")
@localized()
export class LeadEmailPreview extends LitElement {
	public static override styles: CSSResultArray = [styles];

	protected override render(): TemplateResult {
		return html`
			<div class="email">
				<div class="toolbar">
					<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
						<rect x="3" y="6" width="26" height="20" rx="3"></rect>
						<path d="m4 8 12 10L28 8"></path>
					</svg>
					<span>${msg("Doručená pošta", { id: "cooperation-preview-inbox" })}</span>
					<span class="example">${msg("Ukázka e-mailu", { id: "cooperation-preview-example-email" })}</span>
				</div>
				<div class="message-body">
					<h3>${msg("Zájem o prodej bytu v Praze", { id: "cooperation-preview-email-subject" })}</h3>
					<div class="sender">
						<div class="logo">${unsafeSVG(logo)}</div>
						<div>
							<strong>Odhad Zdarma</strong> <span class="sender-address">&lt;info@odhad-zdarma.cz&gt;</span>
							<p class="recipient">
								${msg("Komu: makler@example.com", { id: "cooperation-preview-recipient" })}
								· ${msg("Ukázka e-mailu", { id: "cooperation-preview-example-email" })}
							</p>
						</div>
					</div>
					<p class="message">
						${msg("Majitel nemovitosti má zájem o prodej a požádal o kontakt.", { id: "cooperation-preview-email-message" })}
					</p>
					<dl>
						<div>
							<dt>${msg("Nemovitost", { id: "cooperation-preview-property" })}</dt>
							<dd>${msg("Byt 2+1 · 50 m²", { id: "cooperation-preview-apartment" })}</dd>
						</div>
						<div>
							<dt>${msg("Lokalita", { id: "cooperation-preview-location" })}</dt>
							<dd>${msg("Na Chodovci 2544/34, Praha 4", { id: "cooperation-preview-prague" })}</dd>
						</div>
						<div>
							<dt>${msg("Požadovaná služba", { id: "cooperation-preview-service" })}</dt>
							<dd>${msg("Prodej nemovitosti", { id: "cooperation-preview-property-sale" })}</dd>
						</div>
						<div>
							<dt>${msg("Kontakt na majitele", { id: "cooperation-preview-owner-contact" })}</dt>
							<dd class="contact">${msg("majitel@example.com", { id: "cooperation-preview-owner-email" })}</dd>
						</div>
					</dl>
					<p class="signature">${msg("Tým Odhad Zdarma", { id: "cooperation-preview-email-signature" })}</p>
				</div>
			</div>
		`;
	}
}
